import { render, staticRenderFns } from "./BuyBox.vue?vue&type=template&id=70ccba05&scoped=true"
import script from "./BuyBox.vue?vue&type=script&lang=ts"
export * from "./BuyBox.vue?vue&type=script&lang=ts"
import style0 from "./BuyBox.vue?vue&type=style&index=0&id=70ccba05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ccba05",
  null
  
)

export default component.exports